import { createFileRoute } from "@tanstack/react-router";
import { MessageSquare } from "lucide-react";

export const Route = createFileRoute("/_authenticated/dashboard/markup")({
  component: MarkupPage,
});

function MarkupPage() {
  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center gap-2">
        <MessageSquare size={22} className="text-brand" />
        <h1 className="font-display text-2xl font-bold text-ink">Markup</h1>
      </div>
      <div className="bg-card border border-border rounded-xl p-6 space-y-3">
        <p className="text-sm">
          The Markup tool lets you capture a snapshot of any page, drop pins, draw, and leave
          comments for the developer — like an in-context bug tracker.
        </p>
        <p className="text-sm text-muted-foreground">
          The DB tables for notes, annotations, and replies are already created. The interactive
          canvas + snapshot capture UI ships in a follow-up — ask Lovable to "build the markup
          canvas" to enable this tab.
        </p>
      </div>
    </div>
  );
}
